export default __webpack_public_path__ + "static/media/Summer.34856b54.png";